import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";
import Type from './components/Type';
import img from "./18.png";

const Row = ({ source, onRemove, onUpdate}) => {
    let types = [];
    let adult = source.adult ? <img src={img} style={{ maxWidth: "35px"}}/> : null;

    if(source.types) types = source.types.map(type => <Type type={type} key={type}/>);

    return (<tr>
        <td style={{ textAlign: 'left' }}>{source.name}</td>
        <td>{source.percent}</td>
        <td>{types}</td>
        <td>{adult}</td>
        <td>{source.factor}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(source)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(source.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderSources/components/Table/components/Row/index.js